import { lazy } from "react";

// Lazy-loaded Auth Containers
const ResetPasswordSellerContainer = lazy(() => import("../containers/auth/ResetPasswordSellerContainer"));
const CreateSellerContainer = lazy(() => import("../containers/seller/CreateSellerContainer"));
const SellerLoginContainer = lazy(() => import("../containers/seller/SellerLoginContainer"));

export const authSellerRoutes = [
  { path: "/SellerLogin", component: SellerLoginContainer },
  { path: "/CreateSeller", component: CreateSellerContainer },
  { path: "/ResetPasswordSeller", component: ResetPasswordSellerContainer },
];